export const MESSAGE_HI_IAM_HOPE = 'Hi, I\'m Hope! I\'m Atrium Health\'s virtual assistant. ' +
    'What can I help you with today? Select an option below or type your question to get started.';

export const MESSAGE_STANDARD_INFO = 'If this is a medical emergency, please call 911. '+
    'If this is a mental health crisis, please call our ' +
    '24/7 Behavioral Health Help Line at 704-444-2400.';

export const MESSAGE_HELP_INFO = 'Our agents can help you find a doctor, schedule appointments and answer your questions. ' +
    'Please keep in mind agents are unable to provide medical advice.';

export const MESSAGE_QUEUE_RN_INFO = "Our nurses can assist with answering general questions and " +
    "offering general advice for current Atrium Health patients ages 0-21 years. " +
    "If this is a medical emergency, please call 911. If this is a mental health crisis, " +
    "please call our 24/7 Behavioral Health Help Line at 704-444-2400.";

export const MESSAGE_BILLING_INFO = "If this is a medical emergency, please call 911." +
    "If this is a mental health crisis, please call our 24/7 Behavioral Health Help Line at 704-444-2400";

export const MESSAGE_ESTIMATES_INFO= "If this is a medical emergency, please call 911. " +
    "If this is a mental health crisis, please call our 24/7 Behavioral Health Help Line at 704-444-2400.";

export const MESSAGE_REFERRAL_WMNS_GEN = "If this is a medical emergency, please call 911. " +
    "If this is a mental health crisis, please call our 24/7 Behavioral Health Help Line at 704-444-2400." +
    "<br><br>" +
    "Our team will be happy to help!";


export const QUEUE_NAME_MAIN = 'Main';
export const QUEUE_NAME_GI = 'GI';
export const QUEUE_NAME_CIS = 'CIS';
export const QUEUE_NAME_RN = 'RN'; // Nurse Advice
export const QUEUE_NAME_GLP = 'GLP';
export const QUEUE_NAME_BILLING = 'Billing';
export const QUEUE_NAME_BILLING_ES = 'Spanish Billing';
export const QUEUE_NAME_RADIOLOGY = 'Radiology';
export const QUEUE_NAME_SHVI = 'SHVI';
export const QUEUE_NAME_FLOYD_RADIOLOGY = 'Floyd Radiology';
export const QUEUE_NAME_NAV_RADIOLOGY = 'Nav Radiology';
export const QUEUE_NAME_ESTIMATES = 'Estimates';
export const QUEUE_NAME_NEUROLOGY = 'Neurology';
export const QUEUE_NAME_MEDICAL_RECORDS = 'Medical Records';
export const QUEUE_NAME_HME = "HME";
// export const QUEUE_NAME_HME_CARELINE = "HME Careline";
// export const QUEUE_NAME_HME_COMPLIANCE = "HME Compliance";
// export const QUEUE_NAME_HME_SLEEP = "HME Sleep";
export const QUEUE_NAME_CUSTOMER_SERVICE = "Customer Service";
export const QUEUE_NAME_MSS_REFERRAL = "MSS Referral";
export const QUEUE_NAME_ORAL_MED_REFERRALS = "Oral Med Referrals";

export const QUEUE_NAME_REFERRAL_WMNS_GEN = "Referral WMNS Gen";
export const QUEUE_NAME_REFERRAL_WMNS_GEN_2 = "referral-wmns-gen";

export const QUEUE_NAME_STARTS_WITH_REFERRAL = "Referral";
export const QUEUE_NAME_STARTS_WITH_HME = "HME ";
export const QUEUE_REFERRAL_DENTAL = "Referral Dental";
export const QUEUE_REFERRAL_WAKE_REHAB = "Referral Wake Rehab";
export const QUEUE_REFERRAL_REFERRAL_NEURODIAGNOSTIC = "Referral Neurodiagnostic";

export const LOCAL_STORAGE_KEY_AGENT_DATA = 'LOCAL_STORAGE_KEY_AGENT_DATA';
export const LOCAL_STORAGE_KEY_FEEDBACK_DATA = 'LOCAL_STORAGE_KEY_FEEDBACK_DATA';

